export enum AppOperationCode {
  DQOI = 1,
  OrderSearch = 20
}
